import gql from 'graphql-tag'

export const famIngredient = gql`
  fragment famIngredient on Ingredient {
    name
    display_name
    display_plural
    plural
    frozen_or_canned
    seasons
    with_pork
    unbreakable
    ignore_shopping_list
    store_shelf {
      name
    }
  }
`
